var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import createListItemPlugin from './createListItemPlugin';
import createSimpleHtmlBlockPlugin from './createSimpleHtmlBlockPlugin';
function createSlatePlugins(def, customizers) {
    var _this = this;
    if (customizers === void 0) { customizers = {}; }
    return [
        createSimpleHtmlBlockPlugin({
            type: def.type,
            icon: def.icon,
            label: def.label,
            noButton: def.noButton,
            tagName: def.tagName,
            customAdd: function (editor) { return __awaiter(_this, void 0, void 0, function () {
                var _a, getActiveList, increaseListIndention, currentList, Transforms;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, import('./utils/listUtils')];
                        case 1:
                            _a = _b.sent(), getActiveList = _a.getActiveList, increaseListIndention = _a.increaseListIndention;
                            currentList = getActiveList(editor, def.allListTypes);
                            if (!!currentList) return [3 /*break*/, 2];
                            increaseListIndention(editor, {
                                allListTypes: def.allListTypes,
                                listItemType: def.listItem.type,
                            }, def.type);
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, import('slate')];
                        case 3:
                            Transforms = (_b.sent()).Transforms;
                            Transforms.setNodes(editor, {
                                type: def.type,
                            }, {
                                at: currentList[1],
                            });
                            _b.label = 4;
                        case 4: return [2 /*return*/];
                    }
                });
            }); },
            customRemove: function (editor) { return __awaiter(_this, void 0, void 0, function () {
                var decreaseListIndention;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, import('./utils/listUtils')];
                        case 1:
                            decreaseListIndention = (_a.sent()).decreaseListIndention;
                            decreaseListIndention(editor, {
                                allListTypes: def.allListTypes,
                                listItemType: def.listItem.type,
                            });
                            return [2 /*return*/];
                    }
                });
            }); },
        })(customizers.customizeList),
        createListItemPlugin(def.listItem)(customizers.customizeListItem),
    ];
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function mergeCustomizer(c1, c2) {
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        customizeList: function (def) {
            var def2 = (c1 === null || c1 === void 0 ? void 0 : c1.customizeList) ? c1.customizeList(def) : def;
            return (c2 === null || c2 === void 0 ? void 0 : c2.customizeList) ? c2.customizeList(def2) : def2;
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        customizeListItem: function (def) {
            var def2 = (c1 === null || c1 === void 0 ? void 0 : c1.customizeList) ? c1.customizeListItem(def) : def;
            return (c2 === null || c2 === void 0 ? void 0 : c2.customizeList) ? c2.customizeListItem(def2) : def2;
        },
    };
}
// eslint-disable-next-line @typescript-eslint/ban-types
function createListPlugin(def) {
    var inner = function (innerdef, customizersIn) {
        var customizablePlugin = function (customizers) {
            return inner(innerdef, mergeCustomizer(customizersIn, customizers));
        };
        customizablePlugin.toPlugin = function () {
            return createSlatePlugins(innerdef, customizersIn).map(function (plugin) {
                return plugin.toPlugin();
            });
        };
        return customizablePlugin;
    };
    return inner(def);
}
export default createListPlugin;
//# sourceMappingURL=createListPlugin.js.map